export enum CardButtonSize {
  Long = "long",
  Normal = "normal",
  Small = "small",
  Smaller = "smaller",
  Box = "box",
  Inline = "inline",
}

export enum CardButtonBackground {
  Primary = "primary",
  Secondary = "secondary",
  Tertiary = "tertiary",
  Danger = "danger",
  DangerSecondary = "danger-secondary",
}
